<header>
  <nav
    [style.background-color]="'#65ccf6'"
    class="navbar navbar-expand-md navbar-dark navbar-light"
  >
    <a class="navbar-brand">
      <img src="assets/favicon/favicon.ico" width="30" height="30" alt="" />
    </a>
  </nav>
</header>

<main class="container-fluid d-flex flex-column flex-grow-1 overflow-auto">
  <div class="d-flex flex-column flex-grow-1 p-3 animated fadeIn slow">
    <div *ngIf="responseErrors" class="row">
      <mat-error class="col-sm-12 ml-3">
        <p *ngFor="let message of responseErrors.messages">
          {{ message }}
        </p>
      </mat-error>
    </div>

    <ng-container *ngIf="publicMultiCertificate">
      <div class="row p-4">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h1 class="m-0">{{ publicMultiCertificate.title }}</h1>
              <a
                *ngIf="publicMultiCertificate.link"
                [href]="publicMultiCertificate.link"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-info mt-3"
              >
                Visita nuestra web
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        [style.height]="0"
        class="row row-cols-1 row-cols-md-3 flex-grow-1 overflow-auto p-4 mt-2"
      >
        <div
          *ngFor="let certificate of publicMultiCertificate.certificates"
          class="col mb-4"
        >
          <div class="card mat-elevation-z8">
            <div class="card-header bg-secondary text-white">
              {{ certificate.name }}
            </div>
            <div class="card-body">
              <ul class="list-group list-group-flush">
                <li class="list-group-item d-flex justify-content-start">
                  <h3 class="m-0 mr-2">Nombre:</h3>
                  <h3 class="m-0">{{ certificate.name }}</h3>
                </li>

                <li class="list-group-item d-flex justify-content-start">
                  <h3 class="m-0 mr-2">Tipo:</h3>
                  <h3 class="m-0">{{ certificate.type }}</h3>
                </li>

                <li class="list-group-item d-flex justify-content-start">
                  <h3 class="m-0 mr-2">Estado:</h3>
                  <h3 class="m-0">{{ certificate.status }}</h3>
                </li>

                <li class="list-group-item d-flex justify-content-start">
                  <h3 class="m-0 mr-2">Entidad:</h3>
                  <h3 class="m-0">{{ certificate.entity }}</h3>
                </li>

                <li class="list-group-item d-flex justify-content-start">
                  <h3 class="m-0 mr-2">Fecha de emisión:</h3>
                  <h3 class="m-0">{{ certificate.timestamp }}</h3>
                </li>
              </ul>

              <a
                *ngIf="certificate.link"
                [href]="certificate.link"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-info btn-lg btn-block mt-3"
              >
                Visita nuestra web
              </a>

              <button
                (click)="onDownloadCertificate(certificate)"
                class="btn btn-primary btn-lg btn-block mt-3"
              >
                Descargar certificado
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</main>

<fdx-loader [isLoading]="isLoading"></fdx-loader>
